import { useParams } from 'react-router-dom';

import { DEFAULT_LANGUAGE } from '@/i18next';
import { getAbsolutePath, stripTrailingSlash } from '@/utils/locale';

export function getCanonicalPath(pathname) {
	const { lang } = useParams();
	const absolutePath = getAbsolutePath(pathname);

	if (!lang || lang === DEFAULT_LANGUAGE) {
		return stripTrailingSlash(absolutePath);
	}

	if (!absolutePath) {
		return stripTrailingSlash(`/${lang}`);
	}

	return stripTrailingSlash(`/${lang}${absolutePath}`);
}
